module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/223-turks-and-caicos-9938ceadeafeceafebcf94bf53947ada.svg";